import React from 'react'
import { dateHelper } from '../../helpers/date.helper'
import ReactTooltip from 'react-tooltip'
import copyToClipboard from '../../helpers/clipboard.helper'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'

const StyledDiv = styled.div`
	text-align: center;
	img {
		margin-top: -20px;
	}
	.qrCodeEmv {
		font-size: 0.7em;
		margin-top: 5px;
	}
`
const PixInfo = ({ pixImageQrCode, pixValidity, pixEmv, provider }) => {
	const pixValidityDate = new Date(pixValidity)
	return (
		<StyledDiv className="f-x-large">
			<span className="f-x-large orange">
				Escaneie o código abaixo para efetuar o pagamento:
			</span>
			<p>
				Este Pix tem validade até{' '}
				<b>
					{dateHelper.formatDefault(pixValidityDate)}{' '}
					{dateHelper.getHours(pixValidityDate)}
				</b>
			</p>
			<img
				src={`data:image/png;base64,${pixImageQrCode}`}
				alt="QRCode - PIX"
				title="QRCode - PIX"
			/>
			<div>
				<div>
					Ou utilize o código para pagamento{' '}
					<FontAwesome
						style={{ cursor: 'pointer' }}
						onClick={() => copyToClipboard(pixEmv)}
						name="copy"
						data-tip="Copiar código para área de transferência"
						data-for="copy-tooltip"
					/>
					<ReactTooltip
						id="copy-tooltip"
						aria-haspopup="true"
						effect="solid"
						place="bottom"></ReactTooltip>
				</div>

				<div className="qrCodeEmv">{pixEmv}</div>
				<div>
                    <br/>
					<span STYLE="font-size:10.0pt" >
						Você deve COPIAR a chave pix acima <br/>
                        Abrir o app ou site de seu banco<br/>
                        selecione a opção de pagamento PIX <br/>
                        COLAR o código copiado no app ou site do banco <br/>
                        Tudo ok! Aproveite sua viagem<br/>
					</span>
					<br/>
					<span STYLE="font-size:10.0pt" >
						OBS: Fique atento, evite golpes no meio de pagamento! Antes de finalizar o pagamento 
						no aplicativo do banco confira se o nome do favorecido é:
						Muviflex, {provider === 'ITAU' ? ' Itaú Unibanco S.A.' : 'MOVIM FLEXIBILIDADE DESENV GERENCIAMENTO, BCO SANTANDER (BRASIL) S.A.'}., CNPJ 30.715.948/0001-94. Se não aparecer esses dados,
						não finalize o pagamento. NUNCA faça Transferência PIX DIRETO para a chave 30.715.948/0001-94
						pois nesse caso não teremos como identificar o pagamento, para o pagamento utilize APENAS o QR 
						Code ou link do QR Code fornecidos na finalização do pedido.
					</span>
				</div>
			</div>
		</StyledDiv>
	)
}

export default PixInfo
